import { useTranslation } from 'react-i18next';
import { SvgConsumer } from '@components/icons/svgConsumer';
import {
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerRoot,
  DrawerTitle,
} from '@components/ui/drawer';
import { JobStageMenuSheetProps } from './types';

export const JobStageMenuSheet = ({ open, setOpen, title, items }: JobStageMenuSheetProps) => {
  const { t } = useTranslation('app');

  return (
    <span className="contents" onClick={(e) => e.stopPropagation()}>
      <DrawerRoot open={open} onOpenChange={setOpen} direction="bottom">
        <DrawerContent
          overlayClassName="z-[60] bg-[rgba(24,28,33,.45)]"
          className="max-h-[86vh] rounded-t-2xl border-0 pb-[calc(10px+env(safe-area-inset-bottom,0px))] shadow-[0_-8px_30px_rgba(0,0,0,.18)]">
          <DrawerHeader className="flex flex-row items-center justify-between border-b py-1.5 pl-[18px] pr-2">
            <DrawerTitle className="m-0 text-base font-bold text-neutral-800">{title}</DrawerTitle>
            <DrawerClose asChild>
              <button
                type="button"
                aria-label={t('actions.close')}
                className="flex h-11 w-11 items-center justify-center rounded-md text-xl text-neutral-600 hover:bg-neutral-50">
                <SvgConsumer id="close" />
              </button>
            </DrawerClose>
          </DrawerHeader>
          <ul className="overflow-y-auto overscroll-contain">
            {items.map(({ id, name, onSelect }) => (
              <li key={id}>
                <button
                  type="button"
                  onClick={() => {
                    setOpen(false);
                    onSelect();
                  }}
                  className="flex min-h-[50px] w-full items-center px-[18px] text-left text-base text-neutral-800 active:bg-neutral-50">
                  {name}
                </button>
              </li>
            ))}
          </ul>
        </DrawerContent>
      </DrawerRoot>
    </span>
  );
};
